// Our 1-10 skill bar <-> DUPR (2.0 beginner … 6.0+ elite).
// Same formula as the backend (routes/sports_open_play.py dupr_to_level):
// level = 2 × DUPR − 2, matched to the bar's level descriptions.

export const duprToLevel = (dupr) =>
  Math.max(1, Math.min(10, Math.round((2 * Number(dupr) - 2) * 10) / 10));

export const levelToDupr = (level) => (Math.round(level) + 2) / 2;

export function fmtDupr(level) {
  const d = levelToDupr(level);
  if (d < 2) return 'under 2.0';
  if (d >= 6) return '6.0+';
  return d.toFixed(1);
}

export function fmtDuprRange(lo, hi) {
  return `≈ DUPR ${fmtDupr(lo)}–${fmtDupr(hi)}`;
}

export const hasRange = (div) => div && div.min_level != null && div.max_level != null;

// 'ok' | 'above' | 'below' | null (division has no range)
export function divisionFit(div, level) {
  if (!hasRange(div) || level == null) return null;
  const lv = Math.round(level);
  if (lv < div.min_level) return 'below';
  if (lv > div.max_level) return 'above';
  return 'ok';
}

export function fittingDivision(divs, level) {
  return (divs || []).find(d => divisionFit(d, level) === 'ok') || null;
}

// Two ranged divisions overlap → the message to show, else null.
export function rangeOverlap(divs) {
  const ranged = (divs || []).filter(hasRange).sort((a, b) => a.min_level - b.min_level);
  for (let i = 1; i < ranged.length; i += 1) {
    const a = ranged[i - 1];
    const b = ranged[i];
    if (b.min_level <= a.max_level) {
      return `${a.name} (${a.min_level}–${a.max_level}) and ${b.name} (${b.min_level}–${b.max_level}) overlap — each level can belong to one division only.`;
    }
  }
  return null;
}
